import { MONTH_NAMES } from "~/lib/dateUtils";
import { cn } from "~/lib/utils";
import { PillSelector } from "~/components/ui/pill-selector";

interface MonthSelectorProps {
  value: number[] | null | undefined;
  onChange: (value: number[] | null) => void;
  disabled?: boolean;
  className?: string;
}

export function MonthSelector({ value, onChange, disabled, className }: MonthSelectorProps) {
  const stringValue = value?.map(String) ?? null;

  const handleChange = (newValue: string[] | null) => {
    if (!newValue || newValue.length === 0) {
      onChange(null);
      return;
    }
    const numbers = newValue.map(Number).sort((a, b) => a - b);
    onChange(numbers);
  };

  return (
    <PillSelector.Root
      value={stringValue}
      onChange={handleChange}
      multi
      label="Best months"
      disabled={disabled}
      className={cn("grid grid-cols-3 gap-1.5", className)}
    >
      {MONTH_NAMES.map((name, index) => (
        <PillSelector.Option key={index + 1} value={String(index + 1)}>
          {name}
        </PillSelector.Option>
      ))}
    </PillSelector.Root>
  );
}
